<template>
  <div>
    <b-img
      :src="require('@/assets/images/logo_centered.svg')"
      width="300"
      class="rounded-0"
    />

    <div class="mt-5">
      <h2 class="font-weight-bold">Account Details</h2>
      <!-- <p class="mt-3">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr
      </p> -->
    </div>

    <b-form @submit.prevent="onSubmitInfo" class="mt-4">
      <b-form-group id="input-group-1" class="col-12">
        <i
          class="clearable"
          v-show="form.full_name"
          @click="form.full_name = ''"
          >&times;</i
        >
        <b-form-input
          id="input-1"
          v-model="form.full_name"
          class="input-effect"
          :class="form.full_name ? 'has-content' : ''"
          type="text"
          autofocus
          required
        ></b-form-input>
        <label>Full name</label>
        <div class="input-error" v-if="form.$getError('full_name')">
          {{ form.$getError('full_name')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-2" class="col-12">
        <i
          class="clearable"
          v-show="form.business_name"
          @click="form.business_name = ''"
          >&times;</i
        >
        <b-form-input
          id="input-2"
          v-model="form.business_name"
          class="input-effect"
          :class="form.business_name ? 'has-content' : ''"
          type="text"
          required
        ></b-form-input>
        <label>Business name</label>
        <div class="input-error" v-if="form.$getError('business_name')">
          {{ form.$getError('business_name')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-3" class="col-12">
        <i
          class="clearable"
          v-show="form.business_contact_number"
          @click="form.business_contact_number = ''"
          >&times;</i
        >
        <b-form-input
          id="input-3"
          v-model="form.business_contact_number"
          class="input-effect country-code-pl"
          :class="form.business_contact_number ? 'has-content' : ''"
          type="text"
          required
          @focus="showCountryCode = true"
          @blur="showCountryCode = form.business_contact_number ? true : false"
        ></b-form-input>
        <div class="country-code" v-if="showCountryCode">{{ countryCode }}</div>
        <label>Business contact number</label>
        <div
          class="input-error"
          v-if="form.$getError('business_contact_number')"
        >
          {{ form.$getError('business_contact_number')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-4" class="col-12">
        <place-autocomplete
          v-model="form.business_address"
          name="location"
          :api-key="$env.placesApiKey"
          :input-state="null"
          :input-error="null"
          input-class="ellipsis w-100"
          :prepend-icon="true"
        ></place-autocomplete>
        <div class="input-error" v-if="form.$getError('business_address')">
          {{ form.$getError('business_address')[0] }}
        </div>
      </b-form-group>

      <b-button class="mt-4" type="submit" variant="primary" block>
        <b-spinner class="mr-2" small v-if="form.$busy" />Next
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import PlaceAutocomplete from '@/components/autocomplete/PlaceAutocomplete'

export default {
  components: {
    PlaceAutocomplete
  },

  data() {
    return {
      countryCode: '+61',
      showCountryCode: false,
      gender: [
        { value: null, text: 'Select Gender' },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      form: new Form({
        full_name: '',
        business_name: '',
        business_contact_number: '',
        business_address: ''
      })
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      countries: state => state.country.countries
    }),

    countriesList() {
      return this.countries.map(country => {
        return {
          value: `+${country.dial_code}`,
          text: `${country.flag} ${country.iso3} (+${country.dial_code})`
        }
      })
    }
  },

  methods: {
    ...mapActions({
      getCountries: 'country/getCountries'
    }),

    async onSubmitInfo(evt) {
      this.form.$busy = true
      await this.$api
        .put(`users/${this.user.id}`, {
          full_name: this.form.full_name,
          business_name: this.form.business_name,
          business_contact_number: `${this.countryCode}${
            this.form.business_contact_number
          }`,
          business_address: this.form.business_address
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$store.commit('auth/setUser', data.data.user)
          this.$router.replace({ name: 'job.feed-page' })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  created() {
    this.getCountries()
  },

  watch: {
    'form.full_name'() {
      this.form.$clearError('full_name')
    },
    'form.business_contact_number'() {
      this.form.$clearError('business_contact_number')
    }
  }
}
</script>

<style scoped lang="scss">
.custom-label {
  position: absolute;
  color: #78849e;
  margin-top: -14px;
  font-size: 12px;
}

.custom-input {
  position: absolute;
  border: none;
  margin-top: -32px;
  height: 0px;
  width: 56px;
  margin-left: 3px;
  background: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.display-equal-left {
  width: 20%;
}

.display-equal-right {
  width: 75%;
}

.input-group-append {
  margin-left: -1px;
  margin-right: -2px;
}

.input-group > .form-control:not(:last-child),
.input-group > .country-code-list:not(:last-child) {
  all: none !important;
}

.country-code-pl {
  padding-left: 42px;
}
.country-code {
  position: absolute;
  top: 24px;
  left: 16px;
}
.country-code-list {
  outline: none !important;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -1px;
  z-index: 1;

  &:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 2px solid #2c66d5;
  }
}
</style>
